<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" :key="$route.fullPath"></component>
  </router-view>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
})
</script>
<style>

.ol-dragzoom {
  border-color: black;
  border-width: 2px;
  background-color: rgba(255, 255, 255, 0.4);
}

</style>
